import { create } from 'zustand';
import type { PageMenuItem } from '@/shared/context/PageActionsContext';

interface PageActionsState {
  menuItems: PageMenuItem[];
  setMenuItems: (items: PageMenuItem[]) => void;
  clearMenuItems: () => void;
}

export const usePageActionsStore = create<PageActionsState>((set) => ({
  menuItems: [],
  setMenuItems: (items) => set({ menuItems: items }),
  clearMenuItems: () => set({ menuItems: [] }),
}));
